/**
 * FileVideoIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const FileVideoIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M19 3c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2zM7.8 7h-.6C6.537 7 6 7.56 6 8.25v7.5c0 .69.537 1.25 1.2 1.25h9.6c.663 0 1.2-.56 1.2-1.25V7h-2.4l1.2 2.5H15L13.8 7h-1.2l1.2 2.5H12L10.8 7H9.6l1.2 2.5H9z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const FileVideoIcon = makeIcon('FileVideoIcon', FileVideoIconSvg)
